module.exports = __webpack_public_path__ + "static/media/banner390x520-01.d0eecb93.jpg";